import { Divider, TableCell, TableRow } from "@mui/material";
import { React } from "react";
import { customerDetails } from "../../../../../../utils/content";
import { transactionStyle } from "./Dialog.styles";

const CustomerInfoDialog = (props) => {
  const { customer } = props;
  return (
    <>
      <Divider sx={{ marginBottom: "14px" }} />
      <TableRow>
        <TableCell
          sx={{
            ...transactionStyle.tableCell,
          }}
        >
          Name
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "2%" }}>
          :
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, fontSize: 16 }}>
          {customer.fullName}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          sx={{
            ...transactionStyle.tableCell,
          }}
        >
          Email
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "2%" }}>
          :
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, fontSize: 16 }}>
          {customer.email || "N/A"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          sx={{
            ...transactionStyle.tableCell,
          }}
        >
          Contact Number
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "2%" }}>
          :
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, fontSize: 16 }}>
          {customer.contactNumber || "N/A"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          sx={{
            ...transactionStyle.tableCell,
          }}
        >
          Address
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "2%" }}>
          :
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, fontSize: 16 }}>
          {customer.address || "N/A"}
        </TableCell>
      </TableRow>
    </>
  );
};

export default CustomerInfoDialog;
